import script from "./AuthRegisterForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthRegisterForm.vue?vue&type=script&lang=ts&setup=true"

import "./AuthRegisterForm.vue?vue&type=style&index=0&id=44c3e27a&lang=sass"

const __exports__ = script;

export default __exports__